<div class="auth-status">
  <app-loading></app-loading>
  <h4 class="auth-status-title">{{ "login.processingTenant" | translate }}</h4>
  <div *ngIf="longLoading">
    <p class="auth-status-text">{{ "login.nothing" | translate }}</p>
    <a class="auth-status-link" [routerLink]="['/login']">{{ "login.again" | translate }}</a>
  </div>
</div>
